import axios from '../plugins/axios';

export default {
  loadUserCache() {
    const url = `${process.env.VUE_APP_HIWORKS_CACHE_API}/me`;

    return axios.get(url, {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: 0,
      },
    });
  },
  loadOfficeConfigCache() {
    const url = `${process.env.VUE_APP_HIWORKS_CACHE_API}/office-config`;

    return axios.get(url, {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: 0,
      },
    });
  },

  loadOfficeCurrent() {
    const url = `${process.env.VUE_APP_HIWORKS_CACHE_API}/offices/current`;

    return axios.get(url, {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: 0,
      },
    });
  },

  updateNoticeState() {
    const url = `${process.env.VUE_APP_HIWORKS_CACHE_API}/me/update-notice-state`;

    return axios.post(url, {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: 0,
      },
    });
  },
};
